/* tslint:enable:forbid-import */
import isFeatureEnabled from './isFeatureEnabled';
import type { FeatureName } from '../store/featureDefinitions';

export default function initializeFeature(feature: FeatureName, initialization: () => void): void {
    if (isFeatureEnabled(feature)) {
        initialization();
    }
}
